import Phaser from 'phaser';

export type AmmoType = 'grenade' | 'rocket';

const PICKUP_SIZE = 14;
const PICKUP_RADIUS = 24; // px — collection range

export class AmmoPickup extends Phaser.GameObjects.Container {
  readonly ammoType: AmmoType;
  readonly amount: number;
  private collected: boolean = false;

  constructor(scene: Phaser.Scene, x: number, y: number, type: AmmoType, amount: number) {
    super(scene, x, y);
    this.ammoType = type;
    this.amount = amount;

    const color = type === 'grenade' ? 0x00cc44 : 0xff8800;
    const box = scene.add.rectangle(0, 0, PICKUP_SIZE, PICKUP_SIZE, color).setStrokeStyle(2, 0xffffff);
    const label = scene.add.text(0, 0, type === 'grenade' ? '💣' : '🚀', {
      fontSize: '8px',
    }).setOrigin(0.5, 0.5);

    this.add([box, label]);
    scene.add.existing(this);
    this.setDepth(7);

    // Pulse animation
    scene.tweens.add({
      targets: this,
      scaleX: 1.15,
      scaleY: 1.15,
      duration: 600,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }

  isCollected(): boolean {
    return this.collected;
  }

  tryCollect(soldierX: number, soldierY: number): boolean {
    if (this.collected) return false;
    const dist = Phaser.Math.Distance.Between(soldierX, soldierY, this.x, this.y);
    if (dist <= PICKUP_RADIUS) {
      this.collected = true;
      this.destroy();
      return true;
    }
    return false;
  }
}
